// Utilities to work with server Result JSON and show toastr notifications

import { CONFIG } from '../core/config.js';

function getResultType(result) {
    if (!result) return undefined;
    return result.resultType ?? result.ResultType;
}

function getMessage(result) {
    if (!result) return undefined;
    return result.message ?? result.Message;
}

export function notifyFromResult(result) {
    const msg = getMessage(result) || '';
    const type = getResultType(result);

    if (!msg) return;

    if (type === 0) {
        toastr.success(msg);
        return;
    }
    if (type === 1) {
        toastr.info(msg);
        return;
    }
    if (type === 3) {
        toastr.warning(msg);
        return;
    }
    // Default: treat as error when unknown or explicit error (2) not mapped above
    if (type === 2) {
        toastr.error(msg);
        return;
    }
    toastr.success(msg);
}

export function handleAjaxError(xhr, fallbackMessage = CONFIG.ERROR.FALLBACK_MESSAGE) {
    // Let global handler show the logout message for unauthorized responses
    if (xhr && xhr.status === 401) {
        return;
    }
    // Access denied: inform user and keep them on the page
    if (xhr && xhr.status === 403) {
        showAccessDeniedInfo();
        return;
    }
    const res = xhr && xhr.responseJSON ? xhr.responseJSON : null;
    const msg = getMessage(res) || fallbackMessage;
    const type = getResultType(res);

    if (type === 3) {
        toastr.warning(msg);
        return;
    }
    toastr.error(msg);
}

// Shows info that user has no permission to perform the action
export function showAccessDeniedInfo() {
    toastr.warning(CONFIG.ERROR.ACCESS_DENIED_MESSAGE);
}

// Shows info that session expired and redirects to login
export function showLogoutInfoAndRedirect() {
    let loginUrl = CONFIG.ERROR.LOGIN_URL;
    const returnUrl = window.location.pathname + (window.location.search || '');
    if (returnUrl && returnUrl !== '/') {
        loginUrl += `?ReturnUrl=${encodeURIComponent(returnUrl)}`;
    }
    toastr.options.timeOut = CONFIG.TOASTR.TIMEOUT;
    toastr.options.onHidden = function () {
        window.location.replace(loginUrl);
    };
    toastr.options.onclick = function () {
        window.location.replace(loginUrl);
    };
    toastr.error(CONFIG.ERROR.SESSION_EXPIRED_MESSAGE);
}

// Default jQuery AJAX status code responses used app-wide
export const defaultStatusCodeResponses = {
    401: function () {
        showLogoutInfoAndRedirect();
    },
    403: function () {
        showAccessDeniedInfo();
    }
};

// Wires global handler so all jQuery/Kendo AJAX calls react to 401
export function wireGlobalAjaxUnauthorizedHandler() {
    if (typeof $ !== 'undefined' && $.ajaxSetup) {
        $.ajaxSetup({ statusCode: defaultStatusCodeResponses });
    }
}
